import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  inject,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-info-popup',
  standalone: true,
  imports: [],
  templateUrl: './info-popup.component.html',
  styleUrl: './info-popup.component.scss',
})
export class InfoPopupComponent implements OnInit, OnDestroy {
  @Input({ required: true }) message!: string;
  @Input() autoHide = false;
  @Input() autoHideDelay = 10000; // 10 seconds default

  @Output() closed = new EventEmitter<void>();

  private router = inject(Router);
  private autoHideTimeout?: ReturnType<typeof setTimeout>;
  isVisible = false;

  ngOnInit() {
    // Slight delay for slide-in animation
    setTimeout(() => {
      this.isVisible = true;
    }, 100);

    if (this.autoHide && this.autoHideDelay > 0) {
      this.autoHideTimeout = setTimeout(() => {
        this.close();
      }, this.autoHideDelay);
    }
  }

  ngOnDestroy() {
    if (this.autoHideTimeout) {
      clearTimeout(this.autoHideTimeout);
    }
  }

  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target && target.tagName === 'A') {
      const targetAttr = target.getAttribute('target');
      if (targetAttr === '_blank') {
        this.close();
        return;
      }
      const href = target.getAttribute('href');
      if (href && href.startsWith('/')) {
        event.preventDefault();
        this.router.navigateByUrl(href);
        this.close();
      }
    }
  }

  close() {
    this.isVisible = false;
    // Wait for animation to complete before emitting closed event
    setTimeout(() => {
      this.closed.emit();
    }, 300);
  }
}
